import { Box, Divider, Grid, Stack, Typography, useTheme } from "@mui/material";
import Logo from "components/logo/Logo";
import ReportTable from "components/report/ReportTable/ReportTable";
import { ChartType } from "enums/report";
import { ReportDataDto } from "interfaces/report";
import { cloneDeep, get } from "lodash";
import ReportAttachments from "./ReportAttachments";
import ReportChart from "./ReportChart";
import ReportCommentary from "./ReportCommentary";

interface Props {
  open?: boolean;
  report?: any;
  handleClose?: Function;
  handleSave?: (newReportData: ReportDataDto) => void;
}

export default function PrintReport({ report }: Props) {
  const theme = useTheme();

  const renderSheet = (
    reportData: ReportDataDto,
    sheetName: string,
    chartType: ChartType | undefined,
    commentary: string | undefined
  ) => {
    return (
      <Grid container spacing={2}>
        {sheetName && (
          <Typography
            variant="h4"
            style={{
              paddingLeft: 15,
            }}
          >
            {sheetName}
          </Typography>
        )}

        {chartType && reportData && sheetName && (
          <Grid item xs={12} style={{ marginBottom: 30 }}>
            <ReportChart
              key={(Math.random() + 1).toString(36).substring(7)}
              useCircleChart={
                chartType === ChartType.DOUGHNUT || chartType === ChartType.PIE
              }
              reportData={cloneDeep(reportData)}
              chartType={chartType}
              isOwner={true}
              sheetName={sheetName}
              print
            />
          </Grid>
        )}

        {sheetName && reportData && (
          <Grid
            item
            xs={12}
            style={{
              zoom: reportData[sheetName].yAxis.length > 20 ? 0.5 : "unset",
            }}
          >
            <ReportTable
              isOwner
              reportData={reportData}
              sheetName={sheetName}
              chartType={chartType}
              rotate
            />
          </Grid>
        )}

        {commentary && (
          <>
            <Grid
              item
              xs={12}
              style={{
                marginBottom: 10,
              }}
            >
              <ReportCommentary commentary={commentary} />
            </Grid>
          </>
        )}
      </Grid>
    );
  };

  return (
    <Grid
      container
      style={{
        background: get(theme, "palette.grey.0"),
        zoom: 0.5,
        padding: 35,
      }}
      className="printReport"
    >
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Logo />

        <Typography
          variant="h2"
          key={(Math.random() + 1).toString(36).substring(7)}
          style={{
            textAlign: "center",
            padding: 15,
          }}
        >
          {report.name}
        </Typography>
      </Stack>

      <Divider />

      <Box style={{ marginBottom: 10 }}>
        {Object.keys(report.data).map((currentSheetName) => {
          const chartType = report.data[currentSheetName].chartType;
          const commentary = report.data[currentSheetName].commentary;
          return (
            <div
              style={{
                paddingTop: 20,
                marginTop: "1rem",
                display: "block",
                pageBreakAfter: "always",
              }}
              key={(Math.random() + 1).toString(36).substring(7)}
            >
              {renderSheet(
                report.data,
                currentSheetName,
                chartType,
                commentary
              )}
            </div>
          );
        })}
      </Box>
    </Grid>
  );
}
